var _jsxFileName = "/Users/pjreed/dev/mirador/dist/es/src/components/WindowAuthenticationControl.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Collapse from '@material-ui/core/Collapse';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import LockIcon from '@material-ui/icons/LockSharp';
import SanitizedHtml from '../containers/SanitizedHtml';
/**
 */

export var WindowAuthenticationControl =
/*#__PURE__*/
function (_Component) {
  _inherits(WindowAuthenticationControl, _Component);

  /** */
  function WindowAuthenticationControl(props) {
    var _this;

    _classCallCheck(this, WindowAuthenticationControl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowAuthenticationControl).call(this, props));
    _this.state = {
      open: false,
      showFailureMessage: true
    };
    _this.handleClickOpen = _this.handleClickOpen.bind(_assertThisInitialized(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    _this.handleConfirm = _this.handleConfirm.bind(_assertThisInitialized(_this));
    return _this;
  }
  /** */


  _createClass(WindowAuthenticationControl, [{
    key: "handleClickOpen",
    value: function handleClickOpen() {
      this.setState({
        open: true
      });
    }
    /** */

  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        open: false,
        showFailureMessage: false
      });
    }
    /** */

  }, {
    key: "handleConfirm",
    value: function handleConfirm() {
      var _this$props = this.props,
          handleAuthInteraction = _this$props.handleAuthInteraction,
          infoId = _this$props.infoId,
          serviceId = _this$props.serviceId,
          windowId = _this$props.windowId;
      handleAuthInteraction(windowId, infoId, serviceId);
      this.setState({
        showFailureMessage: true
      });
    }
    /** */

  }, {
    key: "isInteractive",
    value: function isInteractive() {
      var profile = this.props.profile;
      return profile === 'http://iiif.io/api/auth/1/clickthrough' || profile === 'http://iiif.io/api/auth/1/login';
    }
    /** */

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          confirmLabel = _this$props2.confirmLabel,
          degraded = _this$props2.degraded,
          description = _this$props2.description,
          failureDescription = _this$props2.failureDescription,
          failureHeader = _this$props2.failureHeader,
          header = _this$props2.header,
          label = _this$props2.label,
          profile = _this$props2.profile,
          status = _this$props2.status,
          t = _this$props2.t;
      var failed = status === 'failed';
      if ((!degraded || !profile) && status !== 'fetching') return React.createElement(React.Fragment, null);
      if (!this.isInteractive() && !failed) return React.createElement(React.Fragment, null);
      var _this$state = this.state,
          showFailureMessage = _this$state.showFailureMessage,
          open = _this$state.open;
      var isInFailureState = showFailureMessage && failed;
      var hasCollapsedContent = isInFailureState ? failureDescription : header || description;
      var confirmButton = React.createElement(Button, {
        onClick: this.handleConfirm,
        className: classes.buttonInvert,
        autoFocus: true,
        color: "secondary",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 85
        },
        __self: this
      }, confirmLabel || (this.isInteractive() ? t('login') : t('retry')));
      return React.createElement(Paper, {
        square: true,
        elevation: 4,
        color: "secondary",
        classes: {
          root: classes.paper
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 91
        },
        __self: this
      }, React.createElement(Button, {
        fullWidth: true,
        className: classes.topBar,
        onClick: hasCollapsedContent ? this.handleClickOpen : this.handleConfirm,
        component: "div",
        color: "inherit",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 92
        },
        __self: this
      }, React.createElement(LockIcon, {
        className: classes.icon,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 93
        },
        __self: this
      }), React.createElement(Typography, {
        className: classes.label,
        component: "h3",
        variant: "body1",
        color: "inherit",
        inline: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 94
        },
        __self: this
      }, React.createElement(SanitizedHtml, {
        htmlString: (isInFailureState ? failureHeader : label) || t('authenticationRequired'),
        ruleSet: "iiif",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 95
        },
        __self: this
      })), React.createElement("span", {
        className: classes.fauxButton,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 97
        },
        __self: this
      }, hasCollapsedContent ? !open && React.createElement(Typography, {
        variant: "button",
        color: "inherit",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 100
        },
        __self: this
      }, t('continue')) : confirmButton)), hasCollapsedContent && React.createElement(Collapse, {
        "in": open,
        onClose: this.handleClose,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 110
        },
        __self: this
      }, React.createElement(Typography, {
        variant: "body1",
        color: "inherit",
        className: classes.expanded,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 114
        },
        __self: this
      }, isInFailureState ? React.createElement(SanitizedHtml, {
        htmlString: failureDescription || '',
        ruleSet: "iiif",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 117
        },
        __self: this
      }) : React.createElement(React.Fragment, null, React.createElement(SanitizedHtml, {
        htmlString: header || '',
        ruleSet: "iiif",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 120
        },
        __self: this
      }), header && description ? ': ' : '', React.createElement(SanitizedHtml, {
        htmlString: description || '',
        ruleSet: "iiif",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 122
        },
        __self: this
      }))), React.createElement(DialogActions, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 127
        },
        __self: this
      }, React.createElement(Button, {
        onClick: this.handleClose,
        color: "inherit",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128
        },
        __self: this
      }, t('cancel')), confirmButton)));
    }
  }]);

  return WindowAuthenticationControl;
}(Component);
WindowAuthenticationControl.defaultProps = {
  confirmLabel: undefined,
  degraded: false,
  description: undefined,
  failureDescription: undefined,
  failureHeader: undefined,
  header: undefined,
  infoId: undefined,
  label: undefined,
  profile: undefined,
  serviceId: undefined,
  status: null,
  t: function t() {}
};